export const movingMarkerSrc = {
  methods: {
    movingMarkerSrc() {
      return new Promise((resolve, reject) => {
        if (document.getElementById("movingMarker") === null) {
          let script = document.createElement("script");
          script.onload = () => {
            resolve(true);
            return true;
          };
          script.async = true;
          script.src = "/js/MovingMarker.js";
          script.setAttribute("id", "movingMarker");

          document.head.appendChild(script);
        } else {
          resolve(true);
          return true;
        }
      });
    },
  },
};
